import { useCallback, useEffect, useMemo, useState } from 'react';
import { getWindow } from '../../../../lib/getWindow';
import { type DrawerProps, type DrawerRefs, type DrawerSnap } from '../types';

interface useIsFullscreenProps
    extends Pick<DrawerRefs, 'containerRef'>,
        Pick<DrawerProps, 'isFullscreen' | 'isOpen'>,
        Pick<DrawerSnap, 'snapPointSize'> {}

export const useIsFullscreen = ({
    containerRef,
    isFullscreen = false,
    isOpen = false,
    snapPointSize,
}: useIsFullscreenProps) => {
    const [isDrawerFullscreen, setIsDrawerFullscreen] = useState<boolean>(false);

    const updateFullscreen = useCallback(() => {
        if (!isOpen) {
            return;
        }

        const window = getWindow();

        if (!window) {
            return;
        }

        const visibleSize = containerRef.current?.clientHeight || 0;

        if (window.innerHeight <= visibleSize - snapPointSize && snapPointSize <= 0) {
            setIsDrawerFullscreen(true);
        } else {
            setIsDrawerFullscreen(false);
        }
    }, [containerRef, isOpen, snapPointSize]);

    useEffect(() => {
        // eslint-disable-next-line react-hooks/set-state-in-effect -- Автоматический игнор в рамках DIRECT-288723
        updateFullscreen();
    }, [snapPointSize, updateFullscreen]);

    const isFullscreenCombine = useMemo(() => isDrawerFullscreen || isFullscreen, [isDrawerFullscreen, isFullscreen]);

    return {
        isDrawerFullscreen: isFullscreenCombine,
        fullscreenResizeCallback: updateFullscreen,
    };
};
